import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const CommonControllerApiV2 = createApi({
  reducerPath: "CommonControllerApiV2",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    updateReviewRequired: builder.mutation({
      query: ({ questionId, questionType, reviewRequired }: any) => ({
        url: `/question/${questionId}/${questionType}`,
        params: { reviewrequired: reviewRequired },
        method: "PUT"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    updateStakeholder: builder.mutation({
      query: ({ questionId, questionType, body }: any) => ({
        url: `/question/${questionId}/${questionType}/version-details/V2`,
        method: "PUT",
        body: body
      }),
      extraOptions: { service: "MCQ_Assessment" }
    })
  })
});

export const { useUpdateReviewRequiredMutation, useUpdateStakeholderMutation } =
  CommonControllerApiV2;
